import type { CTRL_SCHEMA } from "@repo/sdk/types";
import { useHttp, type HttpConfiguration } from "@repo/utils/hooks";
import { useCtrlClient } from "../contexts/CtrlApiProvider";

export type TenantMemberEntry = CTRL_SCHEMA["OpenapigenTenantMemberEntry"];

export function useTenantMembers(
  tenantId: string | undefined,
  config?: HttpConfiguration,
) {
  const client = useCtrlClient();

  return useHttp<TenantMemberEntry[]>(
    client.token && tenantId ? `tenants/${tenantId}/members` : null,
    async () => {
      return await client.getTenantMembers(tenantId!);
    },
    config,
  );
}
